/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForKubernetes {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return StorageConfigurationBaseForKubernetes.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForKubernetes>): StorageConfigurationBaseForKubernetes {
        let obj = Object.assign(new StorageConfigurationBaseForKubernetes(), model);
        StorageConfigurationBaseForKubernetes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForKubernetes>): StorageConfigurationBaseForKubernetes {
        if (!model) return null;
        return StorageConfigurationBaseForKubernetes.newInstance(<StorageConfigurationBaseForKubernetes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForKubernetes) {
        if (!obj) return;

        models.StorageConfigurationBaseForKubernetes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForKubernetes): boolean {
        switch (obj.type)
        {
            case "StorageConfigurationForAwsKubernetesUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAwsKubernetesUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForAwsKubernetesUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAwsKubernetesUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForAzureKubernetesUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAzureKubernetesUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForAzureKubernetesUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAzureKubernetesUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForGcpKubernetesUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForGcpKubernetesUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForGcpKubernetesUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForGcpKubernetesUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForKubernetesPlatformManaged":
                Object.setPrototypeOf(obj, models.StorageConfigurationForKubernetesPlatformManaged.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof StorageConfigurationBaseForKubernetes)[] {
        return [
            models.StorageConfigurationForAwsKubernetesUserManagedIndividual,
            models.StorageConfigurationForAwsKubernetesUserManagedOnboarded,
            models.StorageConfigurationForAzureKubernetesUserManagedIndividual,
            models.StorageConfigurationForAzureKubernetesUserManagedOnboarded,
            models.StorageConfigurationForGcpKubernetesUserManagedIndividual,
            models.StorageConfigurationForGcpKubernetesUserManagedOnboarded,
            models.StorageConfigurationForKubernetesPlatformManaged,
        ];
    }

    fixupFields() {
    }

}
